<template>
  <div
    class="slider-container d-flex"
    :class="{ select: 'move' }"
    id="gt_inlay"
    :style="{
      width: gt.gtDim.width * 0.5 + 'px',
      height: gt.gtDim.height * 0.5 + 'px',
    }"
  >
    <template v-if="!gt.name.includes('gt6l')">
      <div
        class="gt-btn"
        v-for="(btn, index) in gt.inlay.btns"
        :key="'index_' + index"
        :style="{
          height: calcBtnStyle(btn.style.height),
          width: calcBtnStyle(btn.style.width),
          'background-color': 'lightgrey',
          top: calcBtnStyle(btn.style.top),
          left: calcBtnStyle(btn.style.left),
          'border-radius': btn.style['border-radius'],
          'background-position': 'top',
          'border-bottom': gt.name.includes('mt4 1')
            ? 1 + 'px dashed grey'
            : '',
          'border-right': gt.name.includes('mt4 1') ? 1 + 'px dashed grey' : '',
        }"
      >
        <div
          class="d-flex gt-btn-container"
          :class="[
            btn.content.style['justify-content'],
            btn.content.style['align-items'],
          ]"
        ></div>
      </div>
    </template>
    <template v-if="gt.name.includes('gt6l')">
      <div
        class="gt-btn"
        v-for="(btn, index) in gt.preview.btns"
        :key="'index_' + index"
        :style="{
          height: calcBtnStyle(btn.style.height),
          width: calcBtnStyle(btn.style.width),
          'background-color': 'lightgrey',
          top: calcBtnStyle(btn.style.top),
          left: calcBtnStyle(btn.style.left),
          'border-radius': btn.style['border-radius'],
          'background-position': 'top',
          'border-bottom': gt.name.includes('mt4 1')
            ? 1 + 'px dashed grey'
            : '',
          'border-right': gt.name.includes('mt4 1') ? 1 + 'px dashed grey' : '',
        }"
      >
        <div
          class="d-flex gt-btn-container"
          :class="[
            btn.content.style['justify-content'],
            btn.content.style['align-items'],
          ]"
        ></div>
      </div>
    </template>
    <div
      class="gt-top"
      :style="{
        width: gt.gtDim.width * 0.5 - 4 + 'px',
        height: gt.gtDim.topHeight * 0.5 + 'px',
        'background-image': gt.name.includes('gt10d') ? imgURL() : '',
        'background-size': '60%',
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'z-index': gt.name.includes('gt10d') ? 12 : 10,
      }"
    >
      <template v-if="gt.name.includes('gt10d')">
        <div class="gt10d-button" style="top: 9mm; left: 10mm"></div>
        <div class="gt10d-button" style="top: 9mm; left: 26mm"></div>
        <div class="gt10d-button" style="top: 34mm; left: 10mm"></div>
        <div class="gt10d-button" style="top: 34mm; left: 26mm"></div>
      </template>
    </div>
    <div
      class="gt-right"
      :style="{
        height: gt.gtDim.height * 0.5 - 4 + 'px',
        width: gt.gtDim.rWidth * 0.5 + 'px',
      }"
    ></div>
    <div
      class="gt-left"
      :style="{
        height: gt.gtDim.height * 0.5 - 4 + 'px',
        width: gt.gtDim.lWidth * 0.5 + 'px',
      }"
    ></div>
    <div
      class="gt-bottom"
      :style="{
        width: gt.gtDim.width * 0.5 - 4 + 'px',
        height: gt.gtDim.botHeight * 0.5 + 'px',
      }"
    ></div>
  </div>
</template>

<script>
import { useStore } from "vuex";
export default {
  props: {
    gt: { type: Object, required: true },
    select: { type: Boolean, required: false },
  },
  setup() {
    const store = useStore();
    function imgURL() {
      return "url(" + process.env.BASE_URL + "images/gt/GT10Dw_top.png)";
    }
    function calcBtnStyle(style) {
      return parseFloat(style.split("mm")[0]) * 0.5 + "mm";
    }
    return {
      imgURL,
      calcBtnStyle,
    };
  },
};
</script>

<style lang="scss" scoped>
.slider-container {
  // display: block;
  border: 2px solid grey;
  border-radius: 5px;
  position: relative;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  &:hover {
    cursor: pointer;
  }
  p {
    white-space: pre-line;
  }
}
.gt-btn {
  position: absolute;
}
.gt-btn-img {
  background-repeat: no-repeat;
}

.inlay {
  position: absolute;
  background-repeat: no-repeat;
}
.gt-top,
.gt-bottom {
  position: absolute;
  left: 0;
  z-index: 10;
  background-color: #fff;
}
.gt-top {
  top: 0;
}
.gt-bottom {
  bottom: 0;
}
.gt-right,
.gt-left {
  position: absolute;
  z-index: 10;
  background-color: #fff;
}
.gt-right {
  right: 0;
}
.gt-left {
  left: 0;
}

.inlay-name {
  margin-top: 50px;
}
.gt-btn-container {
  height: inherit;
  position: absolute;
  top: 0;
  left: 0;
}
.led {
  position: absolute;
  background-color: white;
}
.bar_g {
  position: absolute;
  cursor: pointer;
}
.selected {
  border: 1px dashed red;
}
.bar_g_caption {
  position: absolute;
  font-size: 10px;
  line-height: 2.18mm;
  font-weight: bold;
}
.move {
  cursor: move;
}
.gt10d-button {
  width: 8mm;
  border: 1px solid grey;
  position: absolute;
}
</style>
